import ABTestMock from "./ABTestMock";
import CopyOptimizerMock from "./CopyOptimizerMock";
import HookScorerMock from "./HookScorerMock";
import WinnerDetectorMock from "./WinnerDetectorMock";

/* ── Routes each card to its stylized in-product mock panel ── */
const ToolMock = ({ no }) => {
  if (no === "01") return <ABTestMock />;
  if (no === "02") return <CopyOptimizerMock />;
  if (no === "03") return <HookScorerMock />;
  return <WinnerDetectorMock />;
};

export default ToolMock;
